// Contexto de entrada: la plataforma se abre desde distintos puntos
// (QR de sucursal, link del bot de WhatsApp, sitio web, Mi Flux, PWA) y ajusta
// UI y autenticación según cómo llegó el usuario.
//
//   ?src=qr-casilda | wa | web | pwa | miflux   → atribución de origen
//   ?m=miflux | widget                          → modo embebido
//   ?ctx=<token>                                → deep-link de WhatsApp (Fase 2)
//   /w/<token>  (o ?plink=<token>, el formato viejo) → link seguro de un solo
//                                                  uso del bot de WhatsApp
//                                                  (identifica y registra el
//                                                  dispositivo vía /start)
//   #auth=<base64(numero_abonado:token)>        → auth Mi Flux (el fragment no
//                                                  viaja al servidor ni a logs)

export const API_BASE = import.meta.env.VITE_API_BASE || "";

// Site key pública de Cloudflare Turnstile (anti-bot en /start). Vacía = no se
// carga el widget (dev, o bridge con TURNSTILE_ENABLED=false).
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || "";

export function readEntryContext(loc = window.location, hist = window.history) {
  const params = new URLSearchParams(loc.search);
  // Link corto del bot de WhatsApp: /w/<token>. Implica src=walink.
  const shortLink = String(loc.pathname || "").match(/^\/w\/([A-Za-z0-9_-]{16,128})\/?$/);
  const source = sanitizeSource(params.get("src")) || (shortLink ? "walink" : "direct");

  const modeParam = params.get("m");
  const mode = modeParam === "miflux" ? "miflux" : modeParam === "widget" ? "widget" : "standalone";

  const ctx = params.get("ctx") || null;
  const plink = params.get("plink") || shortLink?.[1] || null;

  let auth = null;
  if (loc.hash && loc.hash.startsWith("#auth=")) {
    try {
      const decoded = atob(decodeURIComponent(loc.hash.slice("#auth=".length)));
      const sep = decoded.indexOf(":");
      if (sep > 0) {
        auth = {
          numero_abonado: decoded.slice(0, sep),
          token: decoded.slice(sep + 1)
        };
      }
    } catch {
      auth = null;
    }
  }

  // Limpiar credenciales/token efímero de la URL apenas se leen.
  if ((auth || ctx || plink) && hist?.replaceState) {
    params.delete("ctx");
    params.delete("plink");
    const qs = params.toString();
    hist.replaceState(null, "", (shortLink ? "/" : loc.pathname) + (qs ? `?${qs}` : ""));
  }

  return { source, mode, ctx, plink, auth };
}

function sanitizeSource(value) {
  if (!value) return null;
  return String(value).trim().toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 40) || null;
}
